import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        showPointsAwarded: '<'
    },
    template: `
        <div class="quiz-results" ng-if="vm.formSubmission && vm.formSubmission.form.isResultShown">
            <h2>{{ vm.title }}</h2>
            <ul class="metablock nomargin" ng-if="vm.formSubmission.form.isResultShown">
                <li ng-if="vm.formSubmission.form.timeToAnswer">
                    <div class="value">{{ vm.getDuration() }}</div>
                    <div class="label">{{ 'quiz.Time spent' | translate }}</div>
                </li>
                <li>
                    <div class="value">{{ vm.formSubmission.totalPoints }}/{{ vm.formSubmission.maxScore }}</div>
                    <div class="label">{{ 'quiz.Points awarded' | translate }}</div>
                </li>
                <li ng-if="!vm.formSubmission.form.hasAssessmentQuestions">
                    <div class="value">{{ vm.formSubmission.submissionRate }}%</div>
                    <div class="label">{{ 'quiz.Result (%)' | translate }}</div>
                </li>
            </ul>
            <p class="msg01 msg-ok" ng-if="vm.isAssessmentNeeded()" ng-bind-html="vm.assessmentMsg"></p>
            <p class="msg01 msg-ok" ng-if="vm.formSubmission.isTestPassed && !vm.formSubmission.form.hasAssessmentQuestions">
                {{ 'quiz.Congratulations! You have passed the quiz' | translate }}
            </p>
            <p class="msg01 msg-error" ng-if="!vm.formSubmission.isTestPassed && !vm.formSubmission.form.hasAssessmentQuestions">
                {{ 'quiz.Sorry! You did not pass the quiz' | translate }}
            </p>
            <quiz-finished-overviews
                ng-style="{'width': '100%'}"
                ng-if="vm.formSubmission.form.isCorrectAnswerCountGrouped"
                form-submission="vm.formSubmission"
                selected-language="vm.selectedLanguage"
            />
            <quiz-finished-answers
                ng-style="{'width': '100%'}"
                ng-if="vm.formSubmission.form.isCorrectAnswerShown
                || vm.formSubmission.form.isAnswerFeedbackShown
                || vm.formSubmission.form.isQuestionFeedbackShown
                || vm.formSubmission.form.isTesteesAnswerHighlighted
                || vm.showPointsAwarded"
                show-correct-answers="vm.formSubmission.form.isCorrectAnswerShown"
                show-answer-feedback="vm.formSubmission.form.isAnswerFeedbackShown"
                show-question-feedback="vm.formSubmission.form.isQuestionFeedbackShown"
                show-testees-answers="vm.formSubmission.form.isTesteesAnswerHighlighted"
                show-points-awarded="vm.showPointsAwarded"
                form-submission="vm.formSubmission"
                selected-language="vm.selectedLanguage"
            />
            <p class="mt2em" ng-if="vm.isFeedbackFormAvailable() && !vm.isFeedbackGiven()">{{ 'token.quiz.feedback_text' | translate }}</p>
            <p class="mt2em" ng-if="vm.isFeedbackFormAvailable() && vm.isFeedbackGiven()">{{ 'quiz.Your feedback has already been given' | translate }}</p>
            <ul class="actions01 mt2em center" ng-if="!vm.isFeedbackFormAvailable() || vm.isFeedbackGiven()">
                <li class="primary"><a class="btn main" ng-click="vm.closeQuiz()">{{ 'quiz.Close quiz' | translate }}</a></li>
            </ul>
            <ul class="actions01 mt2em center" ng-if="vm.isFeedbackFormAvailable() && !vm.isFeedbackGiven()">
                <li class="primary"><a class="btn main" ng-click="vm.giveFeedback()">{{ 'quiz.Yes please' | translate }}</a></li>
                <li class="primary"><a class="btn bordered02" ng-click="vm.confirmNoFeedback()">{{ 'quiz.No thanks' | translate }}</a></li>
            </ul>
        </div>
        <div class="quiz-results" ng-if="vm.formSubmission && !vm.formSubmission.form.isResultShown">
            <p class="msg01 msg-ok" ng-if="vm.isAssessmentNeeded()" ng-bind-html="vm.assessmentMsg"></p>
            <p class="msg01 msg-ok" ng-if="!vm.isAssessmentNeeded()">
                {{ 'quiz.Thank you! Your answers have been saved.' | translate }}
            </p>
            <p class="mt2em" ng-if="vm.isFeedbackFormAvailable() && !vm.isFeedbackGiven()">{{ 'token.quiz.feedback_text' | translate }}</p>
            <p class="mt2em" ng-if="vm.isFeedbackFormAvailable() && vm.isFeedbackGiven()">{{ 'quiz.Your feedback is already given' | translate }}</p>
            <ul class="actions01 mt2em center" ng-if="!vm.isFeedbackFormAvailable() || vm.isFeedbackGiven()">
                <li class="primary"><a class="btn main" ng-click="vm.closeQuiz()">{{ 'quiz.Close quiz' | translate }}</a></li>
            </ul>
            <ul class="actions01 mt2em center" ng-if="vm.isFeedbackFormAvailable() && !vm.isFeedbackGiven()">
                <li class="primary"><a class="btn main" ng-click="vm.giveFeedback()">{{ 'quiz.Yes please' | translate }}</a></li>
                <li class="primary"><a class="btn bordered02" ng-click="vm.confirmNoFeedback()">{{ 'quiz.No thanks' | translate }}</a></li>
            </ul>
        </div>
        <div class="quiz-results" ng-if="!vm.formSubmission">
            <p class="msg01 msg-error">
                {{ 'quiz.Results not available' | translate }}
            </p>
            <ul class="actions01 mt2em center" >
                <li class="primary"><a class="btn main" ng-click="vm.closeQuiz()">{{ 'quiz.Close quiz' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($window, $interval, $state, $translate, moment,
                 MomentService, ModalService, FormSubmissionService,
                 FormSubmissionAnswerResource, FormSubmissionResource, QuizQuestionService,
                 FORMS_SUBMISSION_STATUS_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM) {
        this.$window = $window;
        this.$interval = $interval;
        this.$state = $state;
        this.$translate = $translate;
        this.moment = moment;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.FormSubmissionService = FormSubmissionService;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.FormSubmissionResource = FormSubmissionResource;
        this.QuizQuestionService = QuizQuestionService;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
    }

    $onInit () {
        this.$window.scrollTo(0, 0);
        if (this.formSubmission.isTrial) {
            this.selectedLanguage = this.TokenService.getActiveLanguage();
        }
        // check whether quiz is accessed via iframe
        this.inFrame = self !== top;
        this.title = `${this.FormSubmissionService.getQuizTitle(this.formSubmission)} - ${this.$translate.instant('quiz.results')}`;
        this.assessmentMsg = this.$translate.instant('quiz.You have finished the test. The displayed results are not the final results. Some questions still need to be assessed by the lecturer');
    }

    isAssessmentNeeded () {
        return this.formSubmission.form.hasAssessmentQuestions && this.formSubmission.trainingProgress.status === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT;
    }

    closeQuiz () {
        if (this.inFrame) {
            parent.postMessage('closeQuiz()', '*');
        }
        else if (this.formSubmission.isTrial) {
            this.$state.go('authorized.forms.forms.form.general', { id: this.formSubmission.formId });
        }
    }

    getDuration () {
        const start = this.moment.unix(this.formSubmission.startTime);
        const finish = this.moment.unix(this.formSubmission.finishTime);
        const diff = finish - start;
        return this.moment.utc(this.moment.duration(diff).asMilliseconds()).format('HH:mm:ss');
    }

    isFeedbackFormAvailable () {
        if (!this.formSubmission.occurrenceTraining.feedbackFormId) {
            return false;
        }
        return !this.MomentService.isPassedDate(this.formSubmission.occurrenceTraining.feedbackDeadline);
    }

    isFeedbackGiven () {
        return this.formSubmission.feedbackSubmission && this.formSubmission.feedbackSubmission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED;
    }

    giveFeedback () {
        if (this.formSubmission.feedbackSubmission && this.formSubmission.feedbackSubmission.guid) {
            this.$state.go('feedback.form', { guid: this.formSubmission.feedbackSubmission.guid });
        }
        else {
            this.FormSubmissionResource.save({
                name: this.formSubmission.name,
                email: this.formSubmission.email,
                userId: this.formSubmission.userId,
                formId: this.formSubmission.occurrenceTraining.feedbackFormId,
                occurrenceTrainingTimeId: this.formSubmission.occurrenceTrainingTimeId
            }).$promise.then((data) => {
                const guid = data.guid;
                this.FormSubmissionResource.start({ guid }).$promise.then(() => {
                    this.$state.go('feedback.form', { guid });
                });
            });
        }
    }

    confirmNoFeedback () {
        this.ModalService.confirm(this.$translate.instant('quiz.Are you sure you do not want to give feedback?'), 'medium')
            .then(() => {
                this.closeQuiz();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/finished/index.js